import React, { useEffect, useRef, useState } from "react";
import classes from "../Components/WatchlistModal.module.css";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { useAnimationControls, motion } from "framer-motion";
import BackgroundWatchlist from "./BackgroundWatchlist";
import { useNavigate } from "react-router-dom";
import { toggleUserRatingsModal } from "../Slices/userRatingsModalSlice";
import {
  useDeleteUserReviewMutation,
  useEditUserReviewMutation,
  useGetUserReviewsMutation,
} from "../Slices/httpSlice";
import { toast } from "react-toastify";
import Spinner from "./Loaders/Spinner";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { logoutUser } from "../Slices/userSlice";

const UserRatingsModal = () => {
  const lastItemRef = useRef<HTMLDivElement | null>(null);

  const { userRatingsModal } = useAppSelector(
    (state) => state.userRatingsModalSlice
  );

  const { user } = useAppSelector((state) => state.userSlice);

  const [getUserReviews, { isLoading: isLoading }] =
    useGetUserReviewsMutation();

  const [offset, setOffset] = useState<number>(0);
  const [fetchData, setFetchData] = useState<boolean>(false);
  const [userRatings, setUserRatings] = useState([]);

  const [editReview, setEditReview] = useState<any>({
    state: false,
    editReviewId: null,
    reviewStars: 0,
    reviewHeadline: "",
    reviewDescription: "",
  });

  const [deleteReview, setDeleteReview] = useState<any>({
    state: false,
    reviewId: null,
    mediaName: "",
  });

  useEffect(() => {
    if (userRatingsModal) {
      controls.start("visible");
      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [userRatingsModal]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (userRatingsModal && entries[0].isIntersecting && !fetchData) {
          fetchUserRatings();
          setFetchData(true);
        }
      },
      { threshold: 1.0 }
    );

    if (lastItemRef.current) {
      observer.observe(lastItemRef.current);
    }

    return () => {
      if (lastItemRef.current) {
        observer.unobserve(lastItemRef.current);
      }
    };
  }, [userRatingsModal, fetchData, isLoading]);

  const fetchUserRatings = async () => {
    const response: any = await getUserReviews({
      body: {
        user_id: user?.id,
        offset: offset,
      },
      token: user?.token,
    });
    console.log(response, "r");
    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("Your session has expired! Login Again!");
        dispatch(logoutUser(null));
        closeUserRatingsModal();
        navigate("/");

        return;
      }
      toast.error(
        response?.error?.data?.message ||
          response?.error?.data?.error ||
          response?.error?.data ||
          response?.error?.message ||
          "Something Went Wrong!"
      );
    } else {
      if (response?.data?.result.length === 0) {
        return;
      }
      setFetchData(false);
      setOffset(response?.data?.result.length + userRatings.length);
      setUserRatings((prevValue) =>
        prevValue.length > 0
          ? [...prevValue, ...response?.data?.result]
          : response?.data?.result
      );
    }
  };

  console.log({ userRatings, offset, fetchData }, "execution");

  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const controls = useAnimationControls();

  const variants = {
    hidden: {
      y: window.innerHeight,
      display: "none",
    },
    visible: {
      y: 0,
      display: "block",
    },
  };

  const closeUserRatingsModal = () => {
    controls.start("hidden");
    setFetchData(false);
    setOffset(0);
    setUserRatings([]);
    dispatch(toggleUserRatingsModal());
  };

  const [editReviewApi, { isLoading: editLoading }] =
    useEditUserReviewMutation();

  const [deleteReviewApi, { isLoading: deleteLoading }] =
    useDeleteUserReviewMutation();

  const submitHandler = async () => {
    if (
      editReview?.reviewStars === 0 ||
      editReview?.reviewHeadline.trim().length === 0 ||
      editReview?.reviewDescription.trim().length === 0
    ) {
      toast.error(
        "Please ensure all required details for the review are filled out!"
      );
      return;
    }
    const response: any = await editReviewApi({
      body: {
        review_id: editReview?.editReviewId,
        stars: editReview?.reviewStars,
        headline: editReview?.reviewHeadline,
        review: editReview?.reviewDescription,
      },
      token: user?.token,
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("Your session has expired! Login Again!");
        dispatch(logoutUser(null));
        navigate("/");
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setEditReview({
        state: false,
        editReviewId: null,
        reviewStars: 0,
        reviewHeadline: "",
        reviewDescription: "",
      });
      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      fetchUserRatings();
      // closeReviewModal();
      toast.success("Review Edited Successfully!");
    }
  };

  const deleteReviewHandler = async () => {
    const response: any = await deleteReviewApi({
      body: {
        review_id: deleteReview?.reviewId,
      },
      token: user?.token,
    });
    console.log(response, "response....");

    if (response?.error) {
      console.log(response.error, "error");
      if (response?.error?.status === 403) {
        toast.error("Please Login Again, Token Expired!");
      } else {
        toast.error(
          "Something Went Wrong!" ||
            response?.error?.data?.error?.error ||
            response?.error?.data?.error ||
            response?.error?.data?.message ||
            response?.error?.message
        );
      }
    } else {
      setDeleteReview({
        state: false,
        deleteReviewId: null,
        mediaName: "",
      });

      setFetchData(false);
      setOffset(0);
      setUserRatings([]);
      fetchUserRatings();
      // closeReviewModal();
      toast.success("Review Deleted Successfully!");
    }
  };

  return (
    <motion.div
      className={classes.modal}
      variants={variants}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        type: "spring",
        damping: 10,
        stiffness: 100,
      }}
    >
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={closeUserRatingsModal}
          >
            <i className={`pi pi-times ${classes.close_icon}`} />
          </button>
        </div>
        <div className={classes.info_container}>
          <p className={classes.info}>Your Ratings</p>
          <p className={classes.info_brief}>
            Your Ratings is the place to track the titles that you have rated.
          </p>
        </div>
      </BackgroundWatchlist>

      <div className={classes.watchlist_content}>
        <div className={classes.watchlist_header}>
          <p className={classes.watchlist_name}>Your Ratings</p>
        </div>

        <div className={classes.user_rating_wrapper}>
          {userRatings.length === 0 ? (
            <p className={classes.message}>
              You haven't given any ratings yet!
            </p>
          ) : (
            <React.Fragment>
              {userRatings?.map((dataItem: any, idx) => {
                return (
                  <div className={classes.user_rating_container} key={idx}>
                    <button className={classes.main_card_2}>
                      <div className={classes.main_card_image}>
                        <img
                          src={`${process.env.REACT_APP_MEDIA_PATH_PREFIX?.replace(
                            "<replace_media_id>",
                            JSON.parse(dataItem?.media_poster)
                          )}`}
                          alt="movie"
                          className={classes.main_card_img}
                        />
                      </div>
                      <div className={classes.main_card_content}>
                        <p className={classes.main_card_title}>
                          {dataItem?.media_name}
                        </p>
                      </div>
                    </button>

                    <div className={classes.review_card}>
                      {editReview?.state === true &&
                      editReview?.editReviewId === dataItem?.id ? (
                        <form className={classes.form_container}>
                          <div className={classes.review_star_container}>
                            <div className={classes.review_stars}>
                              {Array.from({ length: 10 }).map(
                                (_, idx: number) => {
                                  return (
                                    <>
                                      <motion.i
                                        whileHover={{ color: "yellow" }}
                                        onClick={() =>
                                          setEditReview({
                                            ...editReview,
                                            reviewStars: idx + 1,
                                          })
                                        }
                                        className={`pi ${
                                          editReview?.reviewStars <= idx
                                            ? `pi-star`
                                            : `pi-star-fill`
                                        } ${
                                          editReview?.reviewStars <= idx
                                            ? classes.star_icon
                                            : classes.star_filled_icon
                                        }`}
                                      ></motion.i>
                                    </>
                                  );
                                }
                              )}
                            </div>
                            {editReview?.reviewStars > 0 && (
                              <p className={classes.review_given}>
                                You rated this {editReview?.reviewStars}/10
                              </p>
                            )}
                          </div>

                          <div className={classes.edit_review_inputs_wrapper}>
                            <InputText
                              type="text"
                              className={`p-inputtext-lg ${classes.input_edit_review}`}
                              placeholder="Write a headline for your review here"
                              value={editReview?.reviewHeadline}
                              onChange={(e) =>
                                setEditReview({
                                  ...editReview,
                                  reviewHeadline: e.target.value,
                                })
                              }
                            />

                            <InputTextarea
                              className={`p-inputtext-lg ${classes.input_edit_review} ${classes.textarea}`}
                              placeholder="Write your review here"
                              rows={6}
                              cols={30}
                              value={editReview?.reviewDescription}
                              onChange={(e) =>
                                setEditReview({
                                  ...editReview,
                                  reviewDescription: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className={classes.edit_btns_wrapper}>
                            <button
                              type="button"
                              disabled={editLoading}
                              onClick={() => submitHandler()}
                              className={classes.review_submit_btn}
                            >
                              {editLoading ? (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <Spinner theme="light" />
                                </div>
                              ) : (
                                "Submit"
                              )}
                            </button>
                            <button
                              type="button"
                              // disabled={isLoading}
                              // onClick={() => submitHandler()}
                              className={classes.cancel_edit_review_btn}
                              onClick={() =>
                                setEditReview({
                                  state: false,
                                  editReviewId: null,
                                  reviewDescription: "",
                                  reviewHeadline: "",
                                  reviewStars: 0,
                                })
                              }
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      ) : (
                        <>
                          <div className={classes.review_rating_container}>
                            <img
                              src="/assets/images/star.png"
                              alt="star"
                              className={classes.review_star}
                            />
                            <div
                              className={classes.review_rating_sub_container}
                            >
                              <p className={classes.review_rating}>
                                {dataItem?.stars_rated}
                              </p>
                              <span className={classes.slash}>/</span>
                              <p className={classes.review_rating_out_of}>10</p>
                            </div>
                          </div>

                          <div className={classes.review_intro_container}>
                            <p className={classes.review_headline}>
                              {JSON.parse(dataItem?.review_headline)}
                            </p>
                            <div className={classes.review_by}>
                              <p className={classes.username}>
                                {dataItem?.username}
                              </p>
                              <p className={classes.review_date}>
                                {new Date(
                                  dataItem?.date_time
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "long",
                                  year: "numeric",
                                })}
                              </p>
                            </div>
                          </div>

                          <div className={classes.review_container}>
                            <p
                              className={classes.review}
                              dangerouslySetInnerHTML={{
                                __html: JSON.parse(dataItem?.review).replace(
                                  /\n/g,
                                  "<br />"
                                ),
                              }}
                            ></p>
                          </div>
                          {deleteReview?.state === true &&
                          deleteReview?.reviewId === dataItem?.id ? (
                            <div className={classes.delete_review_btn}>
                              <p className={classes.delete_txt}>
                                Are you sure you want to delete this review on{" "}
                                {deleteReview?.mediaName}
                              </p>
                              <div className={classes.delete_btns_wrapper}>
                                <button
                                  type="button"
                                  className={classes.no_btn}
                                  onClick={() =>
                                    setDeleteReview({
                                      state: false,
                                      reviewId: null,
                                      mediaName: "",
                                    })
                                  }
                                >
                                  No
                                </button>

                                <button
                                  type="button"
                                  disabled={deleteLoading}
                                  onClick={() => deleteReviewHandler()}
                                  className={classes.yes_btn}
                                >
                                  {deleteLoading ? (
                                    <div
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Spinner theme="light" />
                                    </div>
                                  ) : (
                                    "Yes"
                                  )}
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className={classes.review_buttons_wrapper}>
                              <button
                                className={classes.edit_review_btn}
                                onClick={() =>
                                  setEditReview({
                                    state: true,
                                    editReviewId: dataItem?.id,
                                    reviewStars: dataItem?.stars_rated,
                                    reviewHeadline: JSON.parse(
                                      dataItem?.review_headline
                                    ),
                                    reviewDescription: JSON.parse(
                                      dataItem?.review
                                    ),
                                  })
                                }
                              >
                                Edit
                              </button>
                              <button
                                className={classes.delete_review_btn}
                                onClick={() =>
                                  setDeleteReview({
                                    state: true,
                                    reviewId: dataItem?.id,
                                    mediaName: dataItem?.media_name,
                                  })
                                }
                              >
                                Delete
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
            </React.Fragment>
          )}
          {!isLoading && (
            <div ref={lastItemRef} className={classes.load_item}></div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default UserRatingsModal;
